import React, { FC } from 'react';
import definicoescliente from '../../definicoes-cliente.json';

const textData = {
  Titulo: 'Nossos Parceiros',
};

const ParceiroData = [
  {
    ImagemParceiro: '/images/visto-app.png',
  },
  {
    ImagemParceiro: '/images/app-associado-logo-branca.png',
  },
  {
    ImagemParceiro: '/images/grupo-hinova.png',
  },
  {
    ImagemParceiro: '/images/logo-consultor-cor-1.png',
  },
  {
    ImagemParceiro: '/images/power-crm.png',
  },
  {
    ImagemParceiro: '/images/alloyal.png',
  },
];

const Parceiro: FC = () => {
  return (
    <section id="parceiros" className="text-center lg:px-14 bg-theme-gray py-12">
      <h2 className="text-textotitulo text-theme-dark font-bold mb-4">{definicoescliente?.Parceiros?.Titulo || textData.Titulo}</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
        {(definicoescliente.Parceiros.Parceiros.length ? definicoescliente.Parceiros.Parceiros : ParceiroData)
          .map((info, index) => (
          <div key={index} className="flex flex-col items-center p-6">
            <img
              src={info.ImagemParceiro || ParceiroData[index]?.ImagemParceiro}
              alt="Imagem Parceiros"
              className="mb-4 h-24 w-40 object-contain md:h-28 md:w-48"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Parceiro;
